var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronPaginationRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60705 0H5.72142L13.7214 8L5.72135 16H7.60699L15.1356 8.4714L15.607 8L15.1356 7.52853L7.60705 0ZM2.94031 16H1.05469L9.05472 8L1.05475 0H2.94037L10.4689 7.52853L10.9403 8L10.4689 8.4714L2.94031 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronPaginationRight);
export default __webpack_public_path__ + "static/media/chevron-pagination-right.083ddae16989e1c74bfe9cf6088c5e8a.svg";
export { ForwardRef as ReactComponent };